<template lang="pug">
.time-group
  .time-text(v-if="use_type === 'history-today'") 今天
  .time-text(v-if="use_type === 'history-yesterday'") 昨天
  .timetable-main(v-if="courses.length")
    .timetable-item(v-for="(course, index) in courses")
      //- 時間
      .item-time-box
        .item-time {{ course.start_time }}
      //- 課程區塊
      .item-content-box
        //- .item-content(
        //-   v-for="(course, index_in) in course",
        //-   v-bind:class="course.course_lang === 'en' ? 'bg-purple' : course.course_lang === 'ja' ? 'bg-orange' : 'bg-green'"
        //- )
        .item-up
          //- 空心
          .item-point(
            v-if="!course.is_started && !course.is_expired",
            v-bind:class="course.course_lang === 'en' ? 'point-purple' : course.course_lang === 'ja' ? 'point-orange-border' : 'point-green-border'"
          )

          //- 實心
          .item-point(
            v-else,
            v-bind:class="course.course_lang === 'en' ? 'point-purple' : course.course_lang === 'ja' ? 'point-orange' : 'point-green'"
          )

          .item-title 
            .course-name {{ course.title }}
            //- 教師資訊
            .teacher-name(v-if="course.coures_teacher") {{ course.coures_teacher.name }}
            //- 課程長度
            .coruse-length 課程長度: {{ course.course_minutes }} 分鐘
          //- 課程類型
          .item-personal
            img.per-img(src="@/assets/images/desk-chair@3x.png")
            .per-text
              span(v-if="course.course_type === 'PS'") 個人
              span(v-else) 團班
            .clearfix

          //- 語言別
          .item-language
            img.lan-img(src="@/assets/images/lan.png")
            .lan-text
              span(v-if="course.course_lang === 'en'") 美語
              span(v-if="course.course_lang === 'ja'") 日語
              span(v-if="course.course_lang === 'ko'") 韓語
            .clearfix
          .clearfix
      .clearfix
</template>

<script>
export default {
  props: ['timetable_data', 'use_type', 'date_filter', 'language_filter', 'class_filter'],
  data () {
    return {
      todayDate: '',
      yesterdayDate: '',
      courses: []
    }
  },
  created () {
    // 取得今日日期
    let todayDate = new Date();
    // 取得昨日日期
    let yesterdayDate = new Date();
    yesterdayDate.setDate(todayDate.getDate() - 1);

    this.todayDate = this.$root.common.getNowTime('date', (todayDate / 1000))
    this.yesterdayDate = this.$root.common.getNowTime('date', (yesterdayDate / 1000))

    this.getStudentCourse()
  },
  watch: {
    // 當語言選項變更時
    language_filter () {
      this.getStudentCourse()
    },
    // 當班別選項變更時
    class_filter () {
      this.getStudentCourse()
    },
    // 當日期選項變更時
    date_filter () {
      this.getStudentCourse()
    },
  },
  methods: {
    // 依據不同情境調閱課程資料
    getStudentCourse () {
      console.log('--> 開始調閱課程資料: ' + this.use_type)
      // 獲取未來的課程列表
      if (this.use_type === 'home') {
        this.getStudentCourseList(this.language_filter, this.class_filter, this.date_filter)
      }
      // 獲取今日的課程列表
      if (this.use_type === 'history-today') {
        this.getStudentTodayCourseList(this.language_filter, this.class_filter, this.todayDate)
      }
      // 獲取昨日的課程列表
      if (this.use_type === 'history-yesterday') {
        this.getStudentTodayCourseList(this.language_filter, this.class_filter, this.yesterdayDate)
      }
    },
    // 獲取未來的課程列表
    async getStudentCourseList (_courseLang, _courseType, _courseDate) {
      // 開啟載入頁
      this.$root.useLoading()
      // 獲取學員課程資料
      await this.$root.apis.getStudentCourseList(_courseLang, _courseType, _courseDate, this.processCourseListSuccess, this.processCourseListError)
      // 關閉載入頁
      this.$root.closeLoading()
    },
    // 獲得今日的課程列表
    async getStudentTodayCourseList (_courseLang, _courseType, _courseDate) {
      // 開啟載入頁
      this.$root.useLoading()
      // 獲取學員課程資料
      await this.$root.apis.getStudentTodayCourseList(_courseLang, _courseType, _courseDate, this.processCourseListSuccess, this.processCourseListError)
      // 關閉載入頁
      this.$root.closeLoading()
    },
    // 獲得昨日的課程列表
    async getStudentOldCourseList () { },
    // 處理獲得的課程列表資料
    processCourseListSuccess (_response) {
      if (_response.body.error_code !== 0) {
        return this.processCourseListError(_response)
      }

      // 處理課程列表資料
      let courses = _response.body.data


      // 更新畫面資料
      this.courses = courses
    },
    // 處理失敗的課程列表資料
    processCourseListError () {

    }
  }
}
</script>

<style lang="sass" scoped>
.getin-btn
  position: absolute
  right: -1rem
  top: 0rem
  width: 2.5rem
  cursor: pointer
  &:hover
    opacity: .6
  &:active
    opacity: .3
.time-group
  margin-top: .5rem
  width: 33.33333%
  float: left
  padding-right: 3rem
  .time-text
    color: #2e50ff
    text-align: left
    margin-bottom: .5rem
    font-size: .8rem
    font-weight: 500
  .nottime
    padding-top: 30vmin
    color: #191d35
    font-size: 4.3vmin
    font-weight: 500
    line-height: 6vmin
    text-align: center
  .timetable-item
    margin: 0 0 1rem 0
    position: relative
    cursor: pointer
    .item-time-box
      width: 4rem
      text-align: left
      float: left
      font-size: .8rem
      line-height: 1.5rem
      font-weight: 500
      color: #191d35
      .item-time
    .bg-purple
      background: #cceafb
    .bg-green
      background: #e7bbfc
    .bg-orange
      background: #fadbe8

    .item-content-box
      padding-right: 1rem
      width: calc(100% - 4rem)
      float: left
      .item-content
        border-radius: 10px
        width: 100%
        padding: .5rem 1rem
        margin-bottom: .6rem
        position: relative
      .teacher-name
        color: #191d35
        font-size: .9rem
        font-weight: 600
        line-height: 1.6rem
        margin: .3rem 0rem .3rem .9rem

        max-width: 9rem
        margin-top: .8rem
      .coruse-length
        color: #91a1c1
        font-size: .8rem
        font-weight: 500
        line-height: 1.2rem
        margin-left: .9rem
        width: 9rem

      .item-title
        // width: calc(100% - 6vmin)
        color: #191d35
        font-size: .95rem
        font-weight: 500
        line-height: 1.5rem
        text-align: left

      .course-name
        overflow: hidden
        text-overflow: ellipsis
        display: -webkit-box
        -webkit-line-clamp: 2
        -webkit-box-orient: vertical
        white-space: normal

      .item-point
        float: left
        border-radius: 50%
      .point-purple
        background: #8086ff
        width: .5rem
        height: .5rem
        margin: .5rem .5rem .4em 0rem
      .point-green
        background: #49b583
        width: .5rem
        height: .5rem
        margin: .5rem .5rem .4em 0rem
      .point-orange
        background: #ffbd69
        width: .5rem
        height: .5rem
        margin: .5rem .5rem .4em 0rem
      .point-purple-border
        border: 2px solid #8086ff
        width: .5rem
        height: .51rem
        margin: .4rem .5rem .4em 0rem
      .point-green-border
        border: 2px solid #49b583
        width: .5rem
        height: .51rem
        margin: .4rem .5rem .4em 0rem
      .point-orange-border
        border: 2px solid #ffbd69
        width: .5rem
        height: .51rem
        margin: .4rem .5rem .4em 0rem
      .item-language
        text-align: left
        margin: .5rem 1rem .5rem 0rem
        float: left
        .lan-text
          float: left
          font-size: .8rem
          line-height: 1.4rem
          span
            color: #91a1c1
        img.lan-img
          float: left
          height: 1rem
          margin: .2rem .3rem .2rem .2rem
      .item-personal
        text-align: left
        float: left
        margin: .5rem .5rem .5rem .7rem
        .per-text
          float: left
          font-size: .8rem
          line-height: 1.4rem
          span
            color: #91a1c1
        img.per-img
          float: left
          height: 1rem
          margin: .2rem .3rem .2rem .2rem
</style>

